export default "__VITE_ASSET__ea440071__"